<template>
  <v-autocomplete
    variant="outlined"
    density="compact"
    v-model="inputValue"
    v-bind:items="talents"
    v-bind:item-title="(item) => objectTranslator(item, 'TALENT_NAME')"
    v-bind:item-value="(item) => item.TALENT_ID"
    v-bind:rules="rules"
  ></v-autocomplete>
</template>
<script>
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";

export default {
  name: "SpecialSkillCard",
  props: {
    modelValue: String,
  },

  data: () => ({
    rules: [validator.required],
  }),

  methods: {
    objectTranslator,
  },

  computed: {
    talents: function () {
      return this.$store.state.ref.talents;
    },

    inputValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  created() {
    this.$store.dispatch("ref/getTalents");
  },
};
</script>
